import idConfig from 'utils/ecommerce/services/id.config';
import { getLanguage } from 'utils/language/language';
import { env as E } from 'config/app.config';

export interface IGetProductsByParentCategory {
	parentCategory?: string;
	offset: number;
	searchValue?: string;
	limit?: string;
}

export const getProductsByParentCategory = ({
	parentCategory,
	offset,
	searchValue = '',
	limit = '999',
}: IGetProductsByParentCategory) => {
	const language = (idConfig.LANGUAGE as any)[getLanguage().toUpperCase()];
	const storeId = (idConfig.ESHOP as any)?.['PRODUCTS']?.['STORE_ID']?.[E];
	const catalogId = (idConfig.ESHOP as any)?.['PRODUCTS']?.['CATALOG_ID']?.[E];
	const parent = parentCategory || (idConfig.ESHOP as any)?.['PRODUCTS']?.['SMARTPHONES_CATEGORY_ID']?.[E];
	return {
		url: `/search/resources/api/v2/products?currency=OMR&facet=path.tree%3A${parent}&offset=${offset}&searchTerm=${
			searchValue ? searchValue : '*'
		}&storeId=${storeId}&langId=${language}&catalogId=${catalogId}&limit=${limit ?? '999'}&_wcf.search.sort=3`,
		method: 'GET',
	};
};
